import { Component, OnInit } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'trustpilot-carousel-light',
    templateUrl: './trustpilot-carousel-light.component.html',
    styleUrls: ['./trustpilot-carousel-light.component.less'],
})
export class TrustpilotCarouselLightComponent implements OnInit {
    ngOnInit(): void {
        setTimeout(function () {
            // Hack - but without this the noopener button in shown instead of the widget content on page change
            const trustpilotRef = document.getElementById('trustpilot-review-carousel-light');
            window.Trustpilot.loadFromElement(trustpilotRef);
        }, 200);
    }
}
